<div class="solo set-link-activity">
    <section class="child">
        <header ng-show="!showLabel || showLabel === 'true'">
            <h1>{{localize(activity.Trigger.FriendlyName)}}</h1>
        </header>
        <p>{{'setReference.description'|translate}}</p>
        <textarea name="activityReference" ng-model="activity.Reference" />
    </section>
</div>